import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { View } from 'react-native';
import { getTestId, Loader } from '@airtel/air-design-system';
export var PdfViewerWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'PdfViewerWidget' : _props$testID,
    style = props.style,
    pdfUrl = props.pdfUrl;
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var onIframeLoad = () => {
    setLoading(false);
  };
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [style]
  }, {
    children: [loading && _jsx(Loader, {
      label: "Loading ...."
    }), _jsx("iframe", {
      className: "iframe-container",
      id: "iframe",
      src: pdfUrl,
      width: '100%',
      height: 700,
      loading: "eager",
      onLoad: onIframeLoad
    }, pdfUrl)]
  }));
};
PdfViewerWidgetComponent.genericRendererKey = 'AirPdfViewerWidget';